(function( $ ) {

    $('headline_anim').each(function(){
        $(this).splitLines ({
            tag: '<div class="headline-parent"><div class="headline_line"> ',
            width: $(this).width(),
            keepHtml: true
        });
    });


    // const sections = gsap.utils.toArray('.headline_anim');
    // sections.forEach(section => {
    //     $(section).find(".headline-parent").css({
    //         'overflow': 'hidden',
    //         'padding-top': '0.5em',
    //         'margin-top': '-0.5em'
    //     });
    //     var blocks = section.querySelectorAll(".headline_line"); // gsap.set(blocks, {yPercent: 100, opacity: 0});
    //     gsap.from(blocks, {
    //         opacity: 0,
    //         yPercent: -100,
    //         ease: Power3.easeOut,
    //         duration: 1,
    //         stagger: 0.3,
    //         scrollTrigger: {
    //             trigger: blocks,
    //             start: "top 90%",
    //             reverse: false
    //         },
    //         onComplete: function () {
    //             $(section).find(".headline-parent").css({
    //                 'overflow': '',
    //                 'padding-top': '',
    //                 'margin-top': ''
    //             });
    //         }
    //     });
    // });



    const fadeIn = gsap.utils.toArray('.fade_in');
    fadeIn.forEach(section => {
        gsap.from(section, {
            opacity: 0,
            ease: Power3.easeOut,
            duration: 1,
            stagger: 0.3,
            scrollTrigger: {
                trigger: section,
                start: "top 85%",
            },
        });
    });

    const fadeInUP = gsap.utils.toArray('.fade_in_up');
    fadeInUP.forEach(section => {
        gsap.from(section, {
            opacity: 0,
            yPercent: 50,
            ease: Power3.easeOut,
            duration: 1,
            stagger: 0.3,
            scrollTrigger: {
                trigger: section,
                start: "top 85%",
            },
        });
    });

    const fadeInUpPx = gsap.utils.toArray('.fade_in_up_px');
    fadeInUpPx.forEach(section => {
        gsap.from(section, {
            opacity: 0,
            y: 100,
            ease: Power3.easeOut,
            duration: 1,
            stagger: 0.3,
            scrollTrigger: {
                trigger: section,
                start: "top 85%",
            },
        });
    });

    // gsap.set($('.hp__hero_top-headline'), {opacity: 0, immediateRender: true})
    // function heroHeadline() {
    //     const heroHeadline = gsap.utils.toArray('.hp__hero_top-headline');
    //     heroHeadline.forEach(section => {
    //         gsap.to(section, {
    //             opacity: 1,
    //             ease: Power3.easeOut,
    //             duration: 1,
    //             delay: 0,
    //         });
    //     });
    // }

    gsap.set($('.hp__hero_first_button'), {opacity: 0, y: 20, immediateRender: true})
    function heroButton() {
        const heroHeadline = gsap.utils.toArray('.hp__hero_first_button');
        heroHeadline.forEach(section => {
            gsap.to(section, {
                opacity: 1,
                y: 0,
                ease: Power3.easeOut,
                duration: 1,
                delay: 0.2,
            });
        });
    }

    gsap.set($('.hp__hero_right'), {opacity: 0, y: 20, immediateRender: true})



    function heroText() {
        const heroText = gsap.utils.toArray('.hp__hero_top-text');
        heroText.forEach(section => {
            gsap.to(section, {
                opacity: 1,
                x: 0,
                ease: Power3.easeOut,
                duration: 1,
                delay: 0.5,
            });
        });
    }


    function heroLine() {
        const heroText = gsap.utils.toArray('.hp__hero_top-line');
        heroText.forEach(section => {
            gsap.to(section, {
                opacity: 1,
                height: '100%',
                ease: Power3.easeOut,
                duration: 0.8,
                delay: 0,
            });
        });
    }



    // function heroText(){
    //     let logo = $('.hp__hero_first')
    //     gsap.timeline({ onComplete: function() {$('.hp__hero_first-container').addClass('done')}})
    //         .to(logo, {opacity: 1})
    //         .set(".hp__hero_first-container", {
    //             autoAlpha: 1,
    //             display: "block"
    //         })
    //         .from(".hp__hero_first-text", {
    //             xPercent: 50,
    //             duration: 1,
    //         })
    //         .from(".hp__hero_first-container",
    //             {
    //                 width: 0,
    //                 duration: 0.9,
    //             }, "<"
    //         );
    // }

    $(window).on('load', function(){
        // if ($('.hp__hero_first').length){
        //     heroText();
        // }
        if ($('.hp__hero_top-headline').length){
            // heroHeadline();
        }
        if ($('.hp__hero_button').length){
            heroButton();
        }
        if ($('.hp__hero_top-text').length){
            heroText();
            heroLine();
        }
    })
    var windowWidth = $(window).width();
    window.addEventListener('resize', () => {
        if ($(window).width() == windowWidth) return;
        windowWidth = $(window).width();
    });



    // gsap.to(".intro_headline", { x: 200 })

})(jQuery);